import { render, staticRenderFns } from "./admin-empresas.vue?vue&type=template&id=3eeaf9c4&scoped=true"
import script from "./admin-empresas.vue?vue&type=script&lang=js"
export * from "./admin-empresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eeaf9c4",
  null
  
)

export default component.exports